import { render, staticRenderFns } from "./WUserEditPass.vue?vue&type=template&id=72fed8dd&"
import script from "./WUserEditPass.vue?vue&type=script&lang=ts&"
export * from "./WUserEditPass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports